module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "filter-type is-flex"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_vm._m(0), _vm._l((_vm.types), function(o) {
    return _c('div', {
      staticClass: "tag",
      class: {
        'selected': o.selected,
        'new': o.code == 'new'
      },
      on: {
        "click": function($event) {
          return _vm.selectTypeFilter(o)
        }
      }
    }, [_vm._v(_vm._s(o.name))])
  })], 2)]), (!_vm.mini) ? [_c('div', {
    staticClass: "tabs-super-container tabs-minimap",
    attrs: {
      "id": "algorithm-tabs-super-container-minimap"
    }
  }, [_c('div', {
    staticClass: "box-arrow-left minimap actionable-left"
  }, [_c('img', {
    staticClass: "chevron",
    attrs: {
      "src": '/img/icons/left-chevron-' + _vm.mode + '.svg',
      "alt": "Scroll right"
    }
  })]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabParams.minimap.showLeftShadow),
      expression: "tabParams.minimap.showLeftShadow"
    }],
    staticClass: "box-shadow-container left box-shadow-container-left minimap actionable-left"
  }), _c('div', {
    staticClass: "tabs-container tabs-container-actionable",
    style: ('max-width: ' + _vm.tabsContainerMaxWidth + 'px'),
    attrs: {
      "id": "algorithm-tabs-container",
      "data-type": "minimap"
    }
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('ul', _vm._l((_vm.orderedAlgorithms), function(o) {
    return _c('li', {
      class: {
        'active': o.code === _vm.selectedAlgo.code
      },
      on: {
        "click": function($event) {
          return _vm.selectAlgorithm(o, null, 'main')
        }
      }
    }, [_c('a', [_vm._v(_vm._s(o.name))])])
  }), 0)])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabParams.minimap.showRightShadow),
      expression: "tabParams.minimap.showRightShadow"
    }],
    staticClass: "box-shadow-container right box-shadow-container-right minimap actionable-right"
  }), _c('div', {
    staticClass: "box-arrow-right minimap actionable-right"
  }, [_c('img', {
    staticClass: "chevron",
    attrs: {
      "src": '/img/icons/right-chevron-' + _vm.mode + '.svg',
      "alt": "Scroll right"
    }
  })])])] : _vm._e(), _c('div', {
    staticClass: "tabs-super-container",
    class: {
      'mini': _vm.mini
    },
    attrs: {
      "id": "algorithm-tabs-super-container"
    }
  }, [_c('div', {
    staticClass: "box-arrow-left main actionable-left"
  }, [_c('img', {
    staticClass: "chevron",
    attrs: {
      "src": '/img/icons/left-chevron-' + _vm.mode + '.svg',
      "alt": "Scroll right"
    }
  })]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabParams.main.showLeftShadow),
      expression: "tabParams.main.showLeftShadow"
    }],
    staticClass: "box-shadow-container left box-shadow-container-left main actionable-left"
  }), _c('div', {
    staticClass: "tabs-container tabs-container-actionable",
    style: (!_vm.mini ? 'max-width: ' + _vm.tabsContainerMaxWidth + 'px' : ''),
    attrs: {
      "id": "algorithm-tabs-container",
      "data-type": "main"
    }
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('ul', [_vm._l((_vm.orderedAlgorithms), function(o) {
    return (!_vm.mini) ? _c('li', {
      class: {
        'active': o.code === _vm.selectedAlgo.code
      },
      on: {
        "click": function($event) {
          return _vm.selectAlgorithm(o, null, 'minimap')
        }
      }
    }, [_c('a', [_c('div', {
      staticClass: "tab-content"
    }, [(!_vm.mini) ? [_c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "up-text"
    }, [_c('span', {
      class: {
        'has-opacity': o.deactivated
      }
    }, [_vm._v(_vm._s(o.name))]), (o.deactivated) ? _c('div', {
      staticClass: "warning-tag hint--right",
      attrs: {
        "aria-label": "This pool not longer accepts connections."
      }
    }, [_c('span', {
      staticClass: "has-opacity"
    }, [_vm._v("Deprecated")])]) : _vm._e(), (o.new) ? _c('div', {
      staticClass: "new-tag"
    }, [_vm._v("New")]) : _vm._e(), (o.beta) ? _c('div', {
      staticClass: "beta-tag"
    }, [_vm._v("Beta")]) : _vm._e()]), (!_vm.mini) ? _c('div', {
      staticClass: "down-text",
      class: {
        'has-opacity': o.deactivated
      }
    }, [_c('span', [_vm._v("For ")]), _c('b', [_vm._v(_vm._s(o.miningVia))])]) : _vm._e(), _c('div', {
      staticClass: "box-content"
    }, [_c('div', {
      staticClass: "general-main-info-algo"
    }, [_c('div', {
      staticClass: "last-rewarded"
    }, [_c('span', [_vm._v("Algorithm  ")]), _c('b', [_vm._v(_vm._s(o.longName || o.name) + " ")])]), _c('div', {
      staticClass: "last-rewarded"
    }, [_c('span', [_vm._v("Rewards every  ")]), _c('b', {
      staticClass: "last-reward-time FOURALGO"
    }, [(_vm.isLoadingRewardData) ? _c('i', {
      staticClass: "fa fa-circle-o-notch fa-spin"
    }) : _c('b', [_c('span', [_vm._v(_vm._s(o.averageReward))])])])]), _c('div', {
      staticClass: "last-rewarded"
    }, [_c('span', [_vm._v("Last rewarded  ")]), _c('b', {
      staticClass: "timeago last-reward FOURALGO",
      class: {
        'animate': o.lastRewardChanged
      }
    }, [(_vm.isLoadingRewardData) ? _c('i', {
      staticClass: "fa fa-circle-o-notch fa-spin"
    }) : [(o.lastReward > 0) ? _c('b', [_vm._v(_vm._s(_vm._f("fromNow")(o.lastReward)))]) : _c('b', [_vm._v("-")])]], 2)]), _c('div', {
      staticClass: "last-rewarded"
    }, [_c('span', [_vm._v("Based on")]), _c('div', {
      staticClass: "algo-image hint--top",
      attrs: {
        "aria-label": o.symbol
      }
    }, [_c('img', {
      attrs: {
        "src": o.symbolLogo,
        "alt": o.symbol + ' logo'
      }
    })]), _c('span', [_vm._v("mining")]), (o.extraComment) ? _c('span', {
      staticClass: "extra-comment-hint hint--top hint--large is-hidden-mobile",
      attrs: {
        "aria-label": o.extraComment
      }
    }, [_c('i', {
      staticClass: "fa fa-cubes"
    })]) : _vm._e(), (o.symbolDesc != _vm.coin) ? [_c('span', {
      staticClass: "extra-comment-hint hint--top hint--large is-hidden-mobile",
      attrs: {
        "aria-label": 'We will automatically convert ' + o.symbolDesc + ' to ' + _vm.coin + ' on each reward and credit it to your address'
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle"
    })])] : [_c('span', {
      staticClass: "extra-comment-hint hint--top hint--large is-hidden-mobile",
      attrs: {
        "aria-label": 'We will automatically credit ' + _vm.coin + ' to your address'
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle"
    })])]], 2)])])])] : [_c('div', {
      staticClass: "up-text"
    }, [_c('span', {
      class: {
        'has-opacity': o.deactivated
      }
    }, [_vm._v(_vm._s(o.name))]), (o.deactivated) ? _c('div', {
      staticClass: "warning-tag hint--right",
      attrs: {
        "aria-label": "This pool not longer accepts connections."
      }
    }, [_c('span', {
      staticClass: "has-opacity"
    }, [_vm._v("Deprecated")])]) : _vm._e(), (o.new) ? _c('div', {
      staticClass: "new-tag"
    }, [_vm._v("New")]) : _vm._e(), (o.beta) ? _c('div', {
      staticClass: "beta-tag"
    }, [_vm._v("Beta")]) : _vm._e()]), (o.hasNoWorkers) ? _c('div', {
      staticClass: "down-text",
      class: {
        'has-opacity': o.deactivated
      }
    }, [_vm._v("No workers")]) : _vm._e(), (o.workers.length > 0) ? _c('div', {
      staticClass: "down-text",
      class: {
        'has-opacity': o.deactivated
      }
    }, [_c('span', [_vm._v(_vm._s(o.workers.length) + " ")]), (o.workers.length === 1) ? _c('span', [_vm._v("worker")]) : _c('span', [_vm._v("workers")])]) : _vm._e()]], 2)])]) : _vm._e()
  }), _vm._l((_vm.algorithmsFiltered), function(o) {
    return (_vm.mini && !o.hasNoWorkers) ? _c('li', {
      class: {
        'active': o.code === _vm.selectedAlgo.code
      },
      on: {
        "click": function($event) {
          return _vm.selectAlgorithm(o)
        }
      }
    }, [_c('a', [_c('div', {
      staticClass: "tab-content"
    }, [_c('div', {
      staticClass: "up-text"
    }, [_c('span', {
      class: {
        'has-opacity': o.deactivated
      }
    }, [_vm._v(_vm._s(o.name))]), (o.deactivated) ? _c('div', {
      staticClass: "warning-tag hint--right",
      attrs: {
        "aria-label": "This pool not longer accepts connections."
      }
    }, [_c('span', {
      staticClass: "has-opacity"
    }, [_vm._v("Deprecated")])]) : _vm._e(), (o.new) ? _c('div', {
      staticClass: "new-tag"
    }, [_vm._v("New")]) : _vm._e(), (o.beta) ? _c('div', {
      staticClass: "beta-tag"
    }, [_vm._v("Beta")]) : _vm._e()]), (!_vm.mini) ? _c('div', {
      staticClass: "down-text",
      class: {
        'has-opacity': o.deactivated
      }
    }, [_vm._v(_vm._s(o.type))]) : [(o.hasNoWorkers) ? _c('div', {
      staticClass: "down-text",
      class: {
        'has-opacity': o.deactivated
      }
    }, [_vm._v("No workers")]) : _vm._e(), (o.workers.length > 0) ? _c('div', {
      staticClass: "down-text",
      class: {
        'has-opacity': o.deactivated
      }
    }, [_c('span', [_vm._v(_vm._s(o.workers.length) + " ")]), (o.workers.length === 1) ? _c('span', [_vm._v("worker")]) : _c('span', [_vm._v("workers")])]) : _vm._e()]], 2)])]) : _vm._e()
  }), _vm._l((_vm.algorithmsFiltered), function(o) {
    return (_vm.mini && o.hasNoWorkers) ? _c('li', {
      class: {
        'active': o.code === _vm.selectedAlgo.code
      },
      on: {
        "click": function($event) {
          return _vm.selectAlgorithm(o)
        }
      }
    }, [_c('a', [_c('div', {
      staticClass: "tab-content"
    }, [_c('div', {
      staticClass: "up-text"
    }, [_c('span', {
      class: {
        'has-opacity': o.deactivated
      }
    }, [_vm._v(_vm._s(o.name))]), (o.deactivated) ? _c('div', {
      staticClass: "warning-tag hint--right",
      attrs: {
        "aria-label": "This pool not longer accepts connections."
      }
    }, [_c('span', {
      staticClass: "has-opacity"
    }, [_vm._v("Deprecated")])]) : _vm._e(), (o.new) ? _c('div', {
      staticClass: "new-tag"
    }, [_vm._v("New")]) : _vm._e(), (o.beta) ? _c('div', {
      staticClass: "beta-tag"
    }, [_vm._v("Beta")]) : _vm._e()]), (!_vm.mini) ? _c('div', {
      staticClass: "down-text",
      class: {
        'has-opacity': o.deactivated
      }
    }, [_vm._v(_vm._s(o.type))]) : [(o.hasNoWorkers) ? _c('div', {
      staticClass: "down-text",
      class: {
        'has-opacity': o.deactivated
      }
    }, [_vm._v("No workers")]) : _vm._e(), (o.workers.length > 0) ? _c('div', {
      staticClass: "down-text",
      class: {
        'has-opacity': o.deactivated
      }
    }, [_c('span', [_vm._v(_vm._s(o.workers.length) + " ")]), (o.workers.length === 1) ? _c('span', [_vm._v("worker")]) : _c('span', [_vm._v("workers")])]) : _vm._e()]], 2)])]) : _vm._e()
  })], 2)])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabParams.main.showRightShadow),
      expression: "tabParams.main.showRightShadow"
    }],
    staticClass: "box-shadow-container right box-shadow-container-right main actionable-right"
  }), _c('div', {
    staticClass: "box-arrow-right main actionable-right"
  }, [_c('img', {
    staticClass: "chevron",
    attrs: {
      "src": '/img/icons/right-chevron-' + _vm.mode + '.svg',
      "alt": "Scroll right"
    }
  })])])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "title-tag"
  }, [_c('span', [_vm._v("Filter ")]), _c('span', {
    staticClass: "filter-extra-text"
  }, [_vm._v("by tags")]), _c('span', [_vm._v(": ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0edf060c","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_tab_algorithm_select.vue
// module id = 358
// module chunks = 1